<h2 mat-dialog-title class="text-lg font-bold mb-1">Filtrar por</h2>
<mat-dialog-content class="w-full">
      <mat-form-field class="w-full mb-4">
        <mat-label class="block text-gray-700">Clientes</mat-label>
        <mat-select [formControl]="businessPartners" [multiple]="true">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchBusiness" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="changueOptionsBusiness($event)" placeholderLabel="Buscar cliente..."
                noEntriesFoundLabel="No se encontraron resultados">
              </ngx-mat-select-search>
            </mat-option>
            @for (business of businessPartnerList; track business) {
            <mat-option [value]="business">
                <b *ngIf="getCode(business) as code">{{ code }} - </b>{{ business.name }}
            </mat-option>
            }
        </mat-select>
      </mat-form-field>
    <mat-form-field appearance="fill" class="w-full mb-4">
        <mat-label class="text-gray-700">Territorio</mat-label>
        <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione territorio" [multiple]="true"
            class="text-gray-800">
            <mat-option class="p-0">
                <ngx-mat-select-search [showToggleAllCheckbox]="true" [toggleAllCheckboxIndeterminate]="isIndeterminate"
                    [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAll($event)"
                    [formControl]="routeMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                    [placeholderLabel]="'Buscar territorio...'" class="w-full p-3"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let route of filteredRoutes | async" [value]="route"
                class="py-2 px-4 hover:bg-gray-100">
                <span class="flex items-center">
                    <b *ngIf="getCode(route) as code" class="font-semibold text-gray-700">
                        {{ code }} -
                    </b>
                    <span class="text-gray-600">{{ route.name }}</span>
                </span>
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-full mb-4">
        <mat-label for="group-select">Áreas de Rutas</mat-label>
        <mat-select [formControl]="routeAreaMultiCtrl" placeholder="Seleccione las áreas de ruta" [multiple]="true">
            <mat-option>
                <ngx-mat-select-search [showToggleAllCheckbox]="true" [toggleAllCheckboxIndeterminate]="isIndeterminate"
                    [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAllRouteArea($event)"
                    [formControl]="routeAreaMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                    [placeholderLabel]="'Buscar áreas de ruta...'"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let routeArea of filteredRouteAreas | async" [value]="routeArea">
                <span>
                    <b *ngIf="getCode(routeArea) as code">
                        {{ code }} -
                    </b>{{ routeArea.name }}
                </span>

            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-full mb-4">
        <mat-label for="group-select">Ruta</mat-label>
        <mat-select [formControl]="subRouteMultiCtrl" placeholder="Seleccione las rutas" [multiple]="true">
            <mat-option>
                <ngx-mat-select-search [showToggleAllCheckbox]="true"
                    [toggleAllCheckboxIndeterminate]="isIndeterminateSub" [toggleAllCheckboxChecked]="isCheckedSub"
                    (toggleAll)="toggleSelectAllSubRoute($event)" [formControl]="subRouteMultiFilterCtrl"
                    [noEntriesFoundLabel]="'No se encontraron resultados'"
                    [placeholderLabel]="'Buscar rutas...'"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let sub of filteredSubRoute | async" [value]="sub">
                <span>
                    <b *ngIf="getCode(sub) as code">
                        {{ code }} -
                    </b>{{ sub.name }}
                </span>

            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-full mb-4">
        <mat-label for="group-select">Ciudad</mat-label>
        <mat-select [formControl]="locationTwoMultiCtrl" placeholder="Seleccione las ciudades" [multiple]="true">
            <mat-option>
                <ngx-mat-select-search [showToggleAllCheckbox]="true"
                    [toggleAllCheckboxIndeterminate]="isIndeterminateTwo" [toggleAllCheckboxChecked]="isCheckedTwo"
                    (toggleAll)="toggleSelectAllLocationTwo($event)" [formControl]="locationTwoMultiFilterCtrl"
                    [noEntriesFoundLabel]="'No se encontraron resultados'"
                    [placeholderLabel]="'Buscar áreas de ruta...'"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let locationTwo of filteredLocationTwo | async" [value]="locationTwo">
                <span>
                    <b *ngIf="getCode(locationTwo) as code">
                        {{ code }} -
                    </b>{{ locationTwo.name }}
                </span>

            </mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between px-6 pb-4">
    <button mat-button mat-dialog-close class="align-left">
        Cancelar
    </button>
    <button mat-raised-button mat-dialog-close color="primary" (click)="exportToExcel()"  [disabled]="!hasActiveFilters()"
    matTooltip="{{ !hasActiveFilters() ? 'Seleccione al menos un filtro para exportar' : '' }}">
        Exportar
    </button>
</mat-dialog-actions>